import React from "react";
import {
  FlightItinerarySummary,
  BaggageSummary,
  SidebarItem,
  useConfig,
} from "@thekilroygroup/shared-ui";
import { Box } from "@mui/material";
import {
  getFlightCardTranslations,
  getPriceSummaryTranslations,
} from "utils/translationsUtils";
import { getAirlineNames, getAirportName } from "utils/flightDetailApiUtils";
import { useTranslations } from "hooks/useTranslations";
import PriceSummary from "components/PriceSummary/PriceSummary";

import { shoppingCartSelector } from "redux/shoppingCart";
import { useSelector } from "react-redux";
import { IAppConfigObject } from "appConfig.interfaces";
import { itinerarySelector } from "redux/selectedItinerary";

export const CheckoutSidebar = () => {
  const {
    translations,
    translations: { flightSummary },
  } = useTranslations();

  const {
    locale,
    appConfig: { SHARED_ASSETS_BASE_URL },
  } = useConfig<IAppConfigObject>();
  const itinerary = useSelector(itinerarySelector);

  const flightCardTranslations = getFlightCardTranslations(translations);
  const priceSummaryTranslations = getPriceSummaryTranslations(translations);
  const shoppingCart = useSelector(shoppingCartSelector);

  return (
    <Box sx={{ pt: 2, pb: 4 }}>
      <SidebarItem title={translations.priceSummary.tripTitle}>
        <FlightItinerarySummary
          {...flightCardTranslations}
          itinerary={itinerary}
          airlineLogosPath={`${SHARED_ASSETS_BASE_URL}/airline-logos`}
          getAirportName={getAirportName}
          title={flightSummary.details}
          locale={locale}
          defaultExpanded={false}
          getAirlineNames={getAirlineNames}
          flightItinerarySummaryTranslations={flightSummary}
          detailsAccordion={true}
        />
      </SidebarItem>
      <SidebarItem title={translations.baggageSummary.title}>
        <BaggageSummary
          itinerary={itinerary}
          {...flightCardTranslations}
          passengerTypesTranslations={
            flightCardTranslations.baggageInfoTranslations.passengerTypes
          }
        />
      </SidebarItem>
      <SidebarItem title={translations.priceSummary.priceSummaryLabel}>
        <PriceSummary
          itinerary={itinerary}
          paymentLines={shoppingCart.paymentLines}
          priceSummaryTranslations={priceSummaryTranslations}
        />
      </SidebarItem>
    </Box>
  );
};
